import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const createKey = ({ paymentTypeId, currentPaymentStateId } = {}) => [
  'availablePaymentState',
  paymentTypeId,
  currentPaymentStateId,
];

const availablePaymentStateQuery = async ({
  paymentTypeId,
  currentPaymentStateId,
}) => {
  return request.get(
    `/Request/payment_state_by_payment_type`,
    { paymentTypeId, currentPaymentStateId },
    `При загрузке доступных статусов оплаты произошла ошибка`
  );
};

export const useAvailablePaymentState = (params, options) =>
  useQuery(
    createKey(params),
    () => availablePaymentStateQuery(params),
    options
  );
